// @ts-nocheck
import { useState } from 'react';
// eslint-disable-next-line ferp-subgraph-ui/no-direct-mantine-import
import {
  Stack,
  Button,
  Modal,
  TextInput,
  Group,
  Loader,
  Center,
} from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
// eslint-disable-next-line ferp-subgraph-ui/no-direct-mantine-import
import { useDisclosure } from '@mantine/hooks';
import { PageHeader } from '../../components/PageHeader';
import { DataTable, type Column } from '../../components/DataTable';
import { StatusBadge } from '../../components/StatusBadge';
import { useDepartments, useCreateDepartment } from '../../hooks/useCompany';

interface Department {
  [key: string]: unknown;
  id: string;
  name: string;
  status: string;
  parentDepartment?: {
    id: string;
    name: string;
  } | null;
}

interface DepartmentsResponse {
  departments: Department[];
}

export function DepartmentListPage() {
  const [addOpened, { open: openAdd, close: closeAdd }] = useDisclosure(false);
  const [form, setForm] = useState({ name: '', parentDepartmentId: '' });

  const { data: queryData, loading: isLoading } = useDepartments();
  const [createDepartment, { loading: isCreating }] = useCreateDepartment();
  const deptData = queryData as DepartmentsResponse | undefined;
  const departments = deptData?.departments;

  const columns: Column<Department>[] = [
    {
      key: 'name',
      label: 'Name',
      sortable: true,
    },
    {
      key: 'parentDepartment',
      label: 'Parent Department',
      render: (dept) => dept.parentDepartment?.name || '-',
    },
    {
      key: 'status',
      label: 'Status',
      width: 120,
      render: (dept) => <StatusBadge status={dept.status} />,
    },
  ];

  const handleAdd = async () => {
    try {
      await createDepartment({
        variables: {
          input: {
            name: form.name,
            parentDepartmentId: form.parentDepartmentId || null,
          },
        },
      });
      closeAdd();
      setForm({ name: '', parentDepartmentId: '' });
    } catch (error) {
      console.error('Failed to create department:', error);
    }
  };

  return (
    <Stack gap="md">
      <PageHeader
        title="Departments"
        subtitle={departments ? `${departments.length} departments` : undefined}
        actions={
          <Button icon={<IconPlus size={16} />} onClick={openAdd}>
            Add Department
          </Button>
        }
      />

      {isLoading ? (
        <Center py="xl">
          <Loader size="lg" />
        </Center>
      ) : (
        <DataTable<Department>
          data={departments ?? []}
          columns={columns}
          getRowKey={(row) => row.id}
          emptyMessage="No departments found"
        />
      )}

      <Modal
        opened={addOpened}
        onClose={closeAdd}
        title="Add Department"
        size="md"
      >
        <Stack gap="sm">
          <TextInput
            label="Department Name"
            placeholder="Enter department name"
            required
            value={form.name}
            onChange={(e) =>
              setForm((f) => ({ ...f, name: e.currentTarget.value }))
            }
          />
          <TextInput
            label="Parent Department ID"
            placeholder="Optional - enter parent department ID"
            value={form.parentDepartmentId}
            onChange={(e) =>
              setForm((f) => ({
                ...f,
                parentDepartmentId: e.currentTarget.value,
              }))
            }
          />
          <Group justify="flex-end" mt="md">
            <Button variant="subtle" onClick={closeAdd}>
              Cancel
            </Button>
            <Button onClick={handleAdd} disabled={!form.name || isCreating} loading={isCreating}>
              Create Department
            </Button>
          </Group>
        </Stack>
      </Modal>
    </Stack>
  );
}
